// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-search-header {
  align-items: center;
  background: white;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding: 10px 0px 10px 0px;
  width: 100%;
}

.template-selected-file {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/TemplateList.css"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,0BAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AACJ","sourcesContent":[".template-search-header{\n    align-items: center;\n    background: white;\n    display: flex;\n    height: 60px;\n    justify-content: space-between;\n    padding: 10px 0px 10px 0px;\n    width: 100%;\n}\n\n.template-selected-file{\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid;\n    border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
